/**
 * Shared Portrait / Landscape selector for the printable Bookings tabs.
 *
 * A small segmented control that governs the orientation of every PDF a tab
 * generates. Kept here (rather than duplicated) so the Daily Bookings tab and
 * the Summary tab stay identical. Styles live in bookings.css (.orient-toggle),
 * which is bundled globally, so this renders correctly wherever it's used.
 */

export type PdfOrientation = "landscape" | "portrait";

const OPTIONS: { value: PdfOrientation; label: string; hint: string }[] = [
  { value: "landscape", label: "Landscape", hint: "PDFs print landscape (wide)" },
  { value: "portrait", label: "Portrait", hint: "PDFs print portrait (tall)" },
];

export function OrientationToggle({
  value,
  onChange,
}: {
  value: PdfOrientation;
  onChange: (v: PdfOrientation) => void;
}) {
  return (
    <div className="orient-toggle" role="group" aria-label="PDF orientation">
      <span className="orient-toggle__label">Orientation</span>
      <div className="orient-toggle__seg">
        {OPTIONS.map((o) => (
          <button
            key={o.value}
            type="button"
            className={"orient-toggle__opt" + (value === o.value ? " active" : "")}
            aria-pressed={value === o.value}
            onClick={() => onChange(o.value)}
            title={o.hint}
          >
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
